import React, { useContext } from 'react';
import { type ILayerProps, type ITextLayerProps } from '@/version-types';
import { TextLayerContext } from '../context';

type Props = {
    href: string;
    layer: ILayerProps;
};

// ATTENTION: 该组件用于无描边时应用阴影特效
// 因为当有描边时，描边层会应用阴影滤镜

export const ShadowUse: React.FC<Props> = ({ href, layer }) => {
    const { defIDSuffix } = useContext(TextLayerContext)!;

    const { textShadow = [], textStroke = [] } = layer.data as ITextLayerProps;

    if (textShadow.length === 0 || (textStroke.length > 0 && textStroke.some((stroke) => !stroke.hidden))) return null;

    return (
        <React.Fragment>
            {textShadow.map((shadowItem, index) => {
                if (shadowItem.hidden) return null;
                return (
                    <use
                        key={`text-shadow-${layer.id}-${index}`}
                        xlinkHref={href}
                        filter={`url(#shadow-${layer.id}-${index}-${defIDSuffix})`}
                    />
                );
            })}
        </React.Fragment>
    );
};
